export const initialState = {
    roles:[],
    errorState:{status:404,message:'Üzgünüz, Sayfa Bulunamadı'},
    sidebarToggle: false,
    dark: false,
    approvalModal:{open:false,content:''},
    addUserModal:{open:false},
    invoiceInlineApprovalModal: {open:false,invoiceStatusId:null,text:''},
    project:{},
    ongoingData:{currency:'TL'},
    ongoingStatuses:[],
    invoiceStatuses:[],
    crInvoiceStatuses:[],
    crStatuses:[],
    slaInvoiceStatuses:[],
    billsData:[],
    developmentsData:[],
    slaData:[],
    memoData:[],
    projectsData:[],
    tasksData:[],
    task:{},
    usersData:[],
    teknologcies:[],
    edittedRow:{}
}

